import {MindboxTracker} from './mindbox-traker';

export class MindboxOperation {

    constructor() {
        this.mindboxTracker = new MindboxTracker();
    }

    setCart() {
        let _self = this;
        $.ajax({
            url: '/ajax/action/maximaster:widget.mindbox.operation.basket/getdata/',
            type: 'GET',
            success: function (result) {
                if (parseInt(result.code) === 200) {
                    _self.mindboxTracker.setCart(result.data);
                }
            }
        });
    }

    setWishList() {

        let _self = this;
        $.ajax({
            url: '/ajax/action/maximaster:widget.mindbox.operation.favorite/getdata/',
            type: 'GET',
            success: function (result) {
                if (parseInt(result.code) === 200) {
                    _self.mindboxTracker.setWishList(result.data);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./modules/mindbox/mindbox-operation.js